import { Typography } from '../Typography';
import React from 'react';
const DetailListItemEmptyState = () => {
    return (React.createElement(Typography, { component: "span", variant: "subtitle2", color: "textSecondary", display: "inline" }, "Add info"));
};
export default DetailListItemEmptyState;
//# sourceMappingURL=DetailListItemEmptyState.js.map